import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { productClassification, productClassificationType } from '../../types/slices/productClassificationType'

const initialState: productClassificationType =
{
    status: ApiStatus.FETCHED,
    productClassification: [],
    productClassificationSelected: {} as productClassification,
    errorMessage: undefined,
    action: ''
}

const productClassificationSlice = createSlice({
    name: 'productClassificationSlice',
    initialState,
    reducers: {
        onFetchProductClassification (state, { payload }: { payload: productClassification[]}) {
        state.status = ApiStatus.FETCHED
        state.productClassification = payload
        state.errorMessage = undefined
        },
        onSetSelectedProductClassification (state, { payload }: { payload: productClassification }) {
        state.productClassificationSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectProductClassificationState = (state: RootState) => state.productClassificationSlice
export default productClassificationSlice.reducer
export const {
    onFetchProductClassification,
    onSetSelectedProductClassification,
    changeStatus,
    setAction,
} = productClassificationSlice.actions
